import { createHead } from '@unhead/vue/client'

// Shared unhead instance. Created in its own module (rather than inline in main.ts) so non-component
// code can pass it explicitly to useScript() — which otherwise calls injectHead() and only works
// inside component setup. See RecurlyStore.loadRecurly(), triggered from a checkout navigation guard.
export const head = createHead()
